import {
    Box,
    Card,
    CardContent,
    CardMedia,
    Grid,
    Typography,
    Button,
  } from "@mui/material";
  import React from "react";
  
  const serviceCards = [
    {
      id: 1,
      title: "Starter",
      price: "$18",
      description:
        "Personal assistance with installing and setting up DNS and hosting for a basic PHP or WordPress website, ensuring proper configuration and secure access.",
      image: "image-9.png",
      stripeLink: "https://buy.stripe.com/7sI5oq3z14jrbiU289",
    },
    {
      id: 2,
      title: "Advanced",
      price: "$48",
      description:
        "Expert assistance in installing and configuring a Virtual Private Server (VPS), setting up a custom domain, and ensuring secure data transactions through SSL certificates and encryption.",
      image: "image-10.png",
      stripeLink: "https://buy.stripe.com/3cs4km3z17vDcmY146",
    },
    {
      id: 3,
      title: "Ultimate",
      price: "$85",
      description:
        "Complete assistance with installing and configuring a custom domain, setting up a powerful VPS, and deploying a secure corporate mail server to handle up to 50 employee emails.",
      image: "image-11.png",
      stripeLink: "https://buy.stripe.com/dR66su1qT9DLcmYeUX",
    },
    {
      id: 4,
      title: "Supreme",
      price: "$170",
      description:
        "Setup of a custom domain, VPS, corporate mail server, network bandwidth configuration, local storage with automated backups, and advanced network control.",
      image: "image-12.png",
      stripeLink: "https://buy.stripe.com/3cs8AC9Xp5nv1IkeUY",
    },
  ];
  
  const ReliableWebStorageSection = () => {
    return (
      <Box id="order-now-section" sx={{ bgcolor: "#09090f", py: 15, width: "100%" }}>
        <Box sx={{ maxWidth: 1030, mx: "auto" }}>
          <Box sx={{ mb: 10, textAlign: "center" }}>
            <Typography
              variant="h2"
              sx={{
                color: "#fefefe",
                fontSize: "50px",
                fontWeight: 600,
                fontStyle: "italic",
                fontFamily: "'Spline Sans Mono', monospace",
                lineHeight: "60px",
                mb: 2,
              }}
            >
              Reliable Support Services
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#adabab",
                fontSize: "17px",
                maxWidth: 650,
                mx: "auto",
                fontFamily: "'Space Grotesk', sans-serif",
                lineHeight: "26px",
              }}
            >
              Professional web hosting and server configuration services to ensure your digital presence is secure, 
              reliable, and optimized for performance
            </Typography>
          </Box>
  
          <Grid container spacing={4} sx={{p:2, display: "flex", flexWrap: {xs: "wrap", sm: "nowrap"}}}>
            {serviceCards.map((card) => (
              <Grid item xs={12} sm={6} md={3} key={card.id}>
                <Card
                  sx={{
                    bgcolor: "#fabc32",
                    borderRadius: "11px",
                    height: 420,
                    position: "relative",
                    overflow: "visible",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CardMedia
                    // component="img"
                    height="170"
                    // image={card.image}
                    alt={card.title}
                    sx={{ borderRadius: "11px 11px 0 0" }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      width: 70,
                      height: 53,
                      bgcolor: "white",
                      borderRadius: "7px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "22px",
                      fontWeight: 600
                    }}
                  >
                    {card.price}
                  </Box>
                  <CardContent
                    sx={{
                      px: 2.5,
                      pt: 2,
                      pb: "0 !important",
                      flexGrow: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#333",
                        fontSize: "20px",
                        fontWeight: 600,
                        fontFamily: "'Space Grotesk', sans-serif",
                        lineHeight: "26px",
                        mb: 2,
                      }}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#333",
                        fontSize: "15px",
                        fontFamily: "'Space Grotesk', sans-serif",
                        lineHeight: "22px",
                        mb: 3,
                        flexGrow: 1,
                      }}
                    >
                      {card.description}
                    </Typography>
                    <Box sx={{ mt: "auto", mb: 3 }}>
                      <Button
                        variant="contained"
                        href={card.stripeLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          bgcolor: "#09090f",
                          color: "white",
                          fontFamily: "'Space Grotesk', sans-serif",
                          fontWeight: 500,
                          textTransform: "none",
                          borderRadius: "6px",
                          padding: "10px 16px",
                          '&:hover': {
                            bgcolor: "#222",
                          },
                          width: "100%",
                          fontSize: "16px",
                        }}
                      >
                        Subscribe
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    );
  };
  
  export default ReliableWebStorageSection;